import { Component, Input } from '@angular/core';
import { TitleOptions } from 'src/app/models/application-models/title-options';

@Component({
  selector: 'app-common-title',
  templateUrl: './common-title.component.html',
  styleUrls: ['./common-title.component.css']
})
export class CommonTitleComponent {
  @Input() options: TitleOptions;

  constructor() { }
}
